import {
  Button,
  Dialog,
  DialogFooter,
  DialogHeader,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmPayment from "../../../common/shared/ConfirmPayment";
import { useNavigate } from "react-router-dom";

function ManualConference({ amount, year, id, apiFxn, total }) {
  const [manualLoading, setManualLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpen = () => setOpen(!open);
  const handleConfirm = () => setConfirm(!confirm);

  const handleManual = () => {
    setManualLoading(true);
    const formData = {
      amount,
      year,
      id,
      method: 0,
      total,
    };

    dispatch(apiFxn(formData)).finally(() => {
      setManualLoading(false);
      setOpen(true);
    });
  };

  return (
    <>
      <Button onClick={handleConfirm} size="md" color="amber">
        {manualLoading ? <Spinner /> : "Manual Pay"}
      </Button>

      {open && (
        <Dialog open={open} handleOpen={handleOpen}>
          <DialogHeader>
            <Typography variant="h5" color="blue-gray">
              Manual Payment Successfully Added
            </Typography>
          </DialogHeader>
          <DialogFooter>
            <Button
              variant="text"
              color="blue-gray"
              onClick={() => navigate("/home/conferences")}
            >
              Close
            </Button>
          </DialogFooter>
        </Dialog>
      )}

      {confirm && (
        <ConfirmPayment
          open={confirm}
          setOpen={setConfirm}
          title="Manual"
          amount={amount}
          loading={manualLoading}
          handleConfirm={handleManual}
          handleClose={handleConfirm}
        />
      )}
    </>
  );
}

export default ManualConference;
